var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"p-0",attrs:{"md":"12","id":"profile-page"}},[_c('div',{staticClass:"wrapper"},[_c('Header'),_c('Form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }